import { Timestamp } from 'firebase/firestore';

/**
 * Convert Firestore Timestamp to Date
 */
export function toDate(timestamp: Timestamp | Date | undefined | null): Date {
    if (!timestamp) return new Date();
    if (timestamp instanceof Date) return timestamp;
    if (timestamp instanceof Timestamp) return timestamp.toDate();
    // Handle plain objects with seconds/nanoseconds
    if (typeof timestamp === 'object' && 'seconds' in timestamp) {
        return new Date((timestamp as any).seconds * 1000);
    }
    return new Date();
}

/**
 * Convert document data with timestamp fields
 */
export function convertTimestamps<T extends Record<string, any>>(
    data: T,
    timestampFields: (keyof T)[] | readonly (keyof T)[]
): T {
    const converted = { ...data };
    for (const field of timestampFields) {
        if (converted[field]) {
            // safe cast
            (converted as any)[field] = toDate(converted[field] as any);
        }
    }
    return converted;
}

export const TIMESTAMP_FIELDS = {
    user: ['createdAt', 'updatedAt'],
    playlist: ['createdAt', 'updatedAt', 'currentTrack.lastUpdated'],
    track: ['lastVotedAt', 'addedAt'],
    removedTrack: ['lastVotedAt', 'addedAt', 'removedAt'],
    chatMessage: ['createdAt'],
    invite: ['createdAt', 'expiresAt', 'respondedAt'],
    liveSession: ['startedAt', 'lastUpdated'],
} as const;
